import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=12fcbd57&lang=pug"
import script from "./ActionMenu.vue?vue&type=script&lang=ts"
export * from "./ActionMenu.vue?vue&type=script&lang=ts"
import style0 from "./ActionMenu.vue?vue&type=style&index=0&id=12fcbd57&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports